import UploadImages from "components/UploadImages";
import styled from "@emotion/styled";
import { Col, DatePicker, Form, Input, Row, Select, Space, Switch } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { Dispatch, FC, ReactNode, useEffect, useState } from "react";
import { allowFileExtensionsImage } from "config";
import { useAppSelector } from "store";
import dayjs from "dayjs";
import "dayjs/locale/th"; // Import the Thai locale

dayjs.locale("th");

interface PaymentChannelFormProps {
  childrenBank: ReactNode[];
  switchOn: boolean;
  paymentDate: any;
  setPaymentDate: Dispatch<any>;
}

const PaymentChannelForm: FC<PaymentChannelFormProps> = ({
  childrenBank,
  switchOn,
  paymentDate,
  setPaymentDate,
}) => {
  //is_active
  const fullName = useAppSelector((state) => state.auth.profile?.user.name);
  const [switchValue, setSwitchValue] = useState<boolean>(switchOn);

  const dateObject = paymentDate ? dayjs(new Date(paymentDate)) : null;

  // ตั้งค่าเริ่มต้นวันเวลาปัจจุบันเมื่อ mount ถ้ายังไม่มีค่า
  useEffect(() => {
    if (!paymentDate) {
      setPaymentDate(new Date());
    }
  }, []);

  useEffect(() => {
    setSwitchValue(switchOn);
  }, [switchOn]);

  return (
    <Row style={{ backgroundColor: "#EFEFEFEF" }}>
      <Col span={24}>
        <FormWrapper>
          <FormItems
            labelAlign="left"
            label={`การชำระเงิน`}
            name="payment_status">
            <Switch
              checked={switchValue}
              onChange={(checked) => setSwitchValue(checked)}
            />
          </FormItems>
        </FormWrapper>
      </Col>
      {switchValue && (
        <>
          <Col span={12}>
            <FormWrapper>
              <FormItems
                labelAlign="left"
                label="ยอดเงินที่ชำระ"
                name="payment_amount"
                rules={[
                  {
                    required: switchValue,
                    message: "กรุณากรอกยอดเงินที่ชำระ",
                  },
                ]}>
                <Input
                  placeholder="ยอดเงินที่ชำระ"
                  size="small"
                  type="number"
                />
              </FormItems>

              <FormItems
                label="ระบุวันและเวลาที่โอน"
                labelAlign="left"
                name="payment_date"
                // rules={[
                //   {
                //     required: true,
                //     message: "กรุณาระบุวันและเวลาที่โอน",
                //   },
                // ]}
              >
                <DatePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder="ระบุวันและเวลาที่โอน"
                  defaultValue={dateObject ?? undefined}
                  // onChange={handlePaymentDateChange}
                  // ตรวจสอบ dateString ถ้าเป็น array ให้ใช้ตัวแรก เพื่อป้องกัน TS2769
                  onChange={(date, dateString) =>
                    setPaymentDate(
                      date
                        ? new Date(
                            Array.isArray(dateString)
                              ? dateString[0]
                              : dateString
                          )
                        : null
                    )
                  }
                />
              </FormItems>

              <FormItems
                label="หลักฐานการชำระเงิน"
                labelAlign="left"
                name="payment_images">
                <UploadImages
                  maximumUploadItems={1}
                  allowFileExtensions={allowFileExtensionsImage}
                  typeUpload="slip"
                />
              </FormItems>
              <FormItems
                label="บัญชีธนาคาร"
                name="bank_id"
                rules={[{ required: true, message: "กรุณาเลือกบัญชีธนาคาร" }]}>
                <Select
                  placeholder="กรุณาเลือกบัญชีธนาคาร"
                  optionFilterProp="children">
                  {childrenBank}
                </Select>
              </FormItems>
              <FormItems label="บันทึกข้อความ" name="memo">
                <TextArea placeholder="รายละเอียดเพิ่มเติม" rows={5} />
              </FormItems>
            </FormWrapper>
          </Col>
          <Col span={12}>
            <FormWrapper>
              <FormItems labelAlign="left" label="ผู้บันทึกรายการชำระเงิน">
                <Input
                  placeholder="ผู้บันทึกรายการชำระเงิน"
                  size="small"
                  value={fullName}
                  disabled
                />
              </FormItems>
            </FormWrapper>
          </Col>
        </>
      )}
    </Row>
  );
};

export default PaymentChannelForm;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 100%;
`;
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;
// border-radius: 8px;
